import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentParticipantDocument = new CRUD('tournament-participant-documents', 'superior-judge')

export default Object.assign(
    tournamentParticipantDocument,
    {
        reducers: {
            ...tournamentParticipantDocument.reducers
        },

        approve: (id) => {
            return async (dispatch) => {
                dispatch(tournamentParticipantDocument.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participant-documents/${id}/approve`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        decline: (id, message=null) => {
            return async (dispatch) => {
                dispatch(tournamentParticipantDocument.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participant-documents/${id}/decline`, {
                        message
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
